import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        {/* 404 Number */}
        <div className="relative mb-8">
          <h1 className="text-[12rem] sm:text-[16rem] font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400 leading-none">
            404
          </h1>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <AlertCircle size={80} className="text-blue-600/20" />
          </div>
        </div>

        {/* Message */}
        <div className="space-y-4 mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Página não encontrada
          </h2>
          <p className="text-lg text-gray-400 max-w-md mx-auto">
            Parece que a página que você está procurando não existe ou foi movida para outro lugar.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/">
            <Button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-6 text-base">
              <Home size={20} className="mr-2" />
              Voltar para Home
            </Button>
          </Link>
          
          <Link to="/contato">
            <Button 
              variant="outline" 
              className="border-blue-600/50 text-blue-400 hover:bg-blue-600/10 px-8 py-6 text-base"
            >
              <Phone size={20} className="mr-2" />
              Falar Conosco
            </Button>
          </Link>
        </div>

        {/* Help Text */}
        <p className="text-sm text-gray-600 mt-12">
          Se você acredita que isso é um erro, entre em contato conosco pelo WhatsApp
        </p>
      </div>
    </div>
  );
};

export default NotFound;
